import type { GameEvent, GameEventType, PlayerId } from './types';

// Append-only typed event log. Core pushes; renderer / commentary / replay consume.
// hash() gives a deterministic fingerprint for the determinism smoke test.
export class EventLog {
  private events: GameEvent[] = [];

  push(type: GameEventType, t: number, fields: Partial<GameEvent> = {}): void {
    this.events.push({ type, t, ...fields });
  }

  all(): readonly GameEvent[] {
    return this.events;
  }

  since(t: number): GameEvent[] {
    return this.events.filter((e) => e.t > t);
  }

  ofType(type: GameEventType): GameEvent[] {
    return this.events.filter((e) => e.type === type);
  }

  countFor(type: GameEventType, player?: PlayerId): number {
    return this.events.filter((e) => e.type === type && (player === undefined || e.player === player)).length;
  }

  /** FNV-1a over a stable serialization of every event — same seed/run => same hash. */
  hash(): number {
    let h = 0x811c9dc5;
    for (const e of this.events) {
      const s = `${e.type}|${e.t}|${e.player ?? ''}|${e.cell ?? ''}|${e.hazard ?? ''}|${e.value ?? ''}`;
      for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
      }
    }
    return h >>> 0;
  }

  clear(): void {
    this.events = [];
  }
}
